import type { ApiResponse, PaginatedResponse } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';

export interface CreatorFilterItem {
  id: string;
  platformUsername: string;
  name: string;
  profilePictureUrl: string | null;
  platform: string;
}

export type ListCreatorsFilterResponse = PaginatedResponse<CreatorFilterItem>;

interface UseCreatorsQueryFilters {
  search?: string;
  page?: number;
  perPage?: number;
}

export const fetchCreators = async (
  filters: UseCreatorsQueryFilters = {}
): Promise<ListCreatorsFilterResponse> => {
  const params = new URLSearchParams();

  params.append('page', (filters.page || 1).toString());
  params.append('per_page', (filters.perPage || 50).toString());

  if (filters.search && filters.search.length > 0) {
    params.append('search', filters.search);
  }

  const { data } = await api.get<ApiResponse<ListCreatorsFilterResponse>>(
    `/dashboard/creators?${params.toString()}`
  );

  if (!data.data) {
    throw new Error('Invalid response structure');
  }

  return data.data;
};

export const useCreatorsQuery = (filters: UseCreatorsQueryFilters = {}, enabled = true) => {
  return useQuery<ListCreatorsFilterResponse, Error>({
    queryKey: ['creators', 'brand-mentioned', filters.search, filters.page, filters.perPage],
    queryFn: () => fetchCreators(filters),
    staleTime: 60 * 1000,
    enabled,
  });
};
